var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-bg"}),_vm._t("terms"),_c('div',{staticClass:"modal-content"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }